export function sanitizeTenantName(tenantName: string): string {
  return tenantName
    .replace(/_/g, ' ')
    .split(/(\s|-)/) // split by space and dash, preserving separators
    .map((word) => (word[0] ? word[0].toUpperCase() + word.slice(1) : '')) // capitalize first letter of each word
    .join(''); // join words back together
}
